<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>person_pin</md-icon>
          </div>
          <h4 class="title">新增系统模型</h4>
        </md-card-header>
        <md-card-content>
          <collapse
            :collapse="['基础信息', '属性', '行为']"
            icon="keyboard_arrow_down"
            color-collapse="success"
            class="md-collapse"
          >
            <template slot="md-collapse-pane-1">
              <div class="md-layout">
                <div class="md-layout-item md-size-100 mx-auto">
                  <md-field>
                    <label>课程</label>
                    <md-select v-model="$data.course" name="course" id="course">
                      <md-option value="bk">变电站运维与检修</md-option>
                    </md-select>
                    <span class="md-helper-text"> 与专业匹配或为虚拟团队</span>
                  </md-field>
                  <md-field>
                    <label>项目名称</label>
                    <md-select
                      v-model="$data.project"
                      name="project"
                      id="project"
                    >
                      <md-option value="yw">变电站运维</md-option>
                      <md-option value="jx">变电站检修</md-option>
                    </md-select>
                    <span class="md-helper-text"> 请输入实训项目名称</span>
                  </md-field>

                  <md-field>
                    <label>系统元件名称</label>
                    <md-input v-model="$data.name" type="text"> </md-input>
                    <span class="md-helper-text"> 请输入系统元件名称</span>
                  </md-field>
                  <md-field>
                    <label>系统元件类型</label>
                    <md-select
                      v-model="$data.project"
                      name="project"
                      id="project"
                    >
                      <md-option value="ui">UI</md-option>
                      <md-option value="sxj">摄像机</md-option>
                      <md-option value="lp">录屏</md-option>
                    </md-select>
                  </md-field>
                  <md-field>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-20 md-small-size-100">
                        <label style="padding-top: 5px">是否公开</label>
                      </div>
                      <div class="md-layout-item md-size-80 md-small-size-100">
                        <md-switch v-model="switch1"></md-switch>
                      </div>
                    </div>
                  </md-field>
                  <md-field>
                    <label>系统元件描述</label>
                    <md-textarea v-model="$data.desc" md-autogrow></md-textarea>
                    <span class="md-helper-text">
                      请输入系统元件描述,控制在1000字内</span
                    >
                  </md-field>
                </div>
              </div>
            </template>
            <template slot="md-collapse-pane-2">
              <md-field>
                <label>行为名称</label>
                <md-input v-model="act_name" type="text"> </md-input>
                <span class="md-helper-text"> 请输入行为名称</span>
              </md-field>
              <md-field>
                <label>行为描述</label>
                <md-textarea v-model="act_desc"></md-textarea>
                <span class="md-helper-text">
                  请输入角色描述,控制在1000字内</span
                >
              </md-field>
            </template>
            <template slot="md-collapse-pane-3">
              <md-field>
                <label>行为名称</label>
                <md-input v-model="act_name" type="text"> </md-input>
                <span class="md-helper-text"> 请输入行为名称</span>
              </md-field>
              <md-field>
                <label>行为描述</label>
                <md-textarea v-model="act_desc"></md-textarea>
                <span class="md-helper-text">
                  请输入角色描述,控制在1000字内</span
                >
              </md-field>
            </template>
          </collapse>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-success" @click="toSystem">确 定</md-button
          >&nbsp;&nbsp;&nbsp;
          <md-button class="md-success" @click="toSystem">返 回</md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Collapse } from "@/components";
export default {
  data() {
    return {
      switch1: true,
      name: "巡视员",
      manager: "林力明",
    };
  },
  components: {
    Collapse,
  },
  methods: {
    toSystem() {
      this.$router.push({ path: "./systemmod" });
    },
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>